"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var projectActions = require("@caddigital/sok-reducers/lib/actions/project/wizard");
var GenericInviteModal_1 = require("components/modals/GenericInviteModal");
var mapStateToProps = function (state) { return ({
    projectId: state.project.wizard.step1.id,
    isOpen: state.project.wizard.step3.invite.isOpen,
    status: state.project.wizard.step3.invite.status,
    inviteRows: state.project.wizard.step3.invite.inviteRows,
    errors: state.project.wizard.step3.invite.errors,
    all: state.project.wizard.step3.groups,
    userGroupsStatus: state.project.wizard.step3.status
}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return dispatch(projectActions.UsergroupInvite.clear()); },
    selectItem: function (uuid, itemId) {
        dispatch(projectActions.UsergroupInvite.inviteSelectItem(uuid, itemId));
    },
    addNewRow: function (item) {
        return dispatch(projectActions.UsergroupInvite.addRow(item.uuid, item.group, item.emails, item.language));
    },
    removeRow: function (uuid) {
        return dispatch(projectActions.UsergroupInvite.removeRow(uuid));
    },
    updateEmails: function (uuid) { return function (email) {
        return dispatch(projectActions.UsergroupInvite.updateEmails(uuid, email));
    }; },
    updateLanguage: function (uuid, language) {
        return dispatch(projectActions.UsergroupInvite.UpdateLanguage(uuid, language));
    },
    addNewToast: function (title, message, type) {
        return dispatch(toastActions.addNewToast(title, message, type));
    },
    sendInvitations: function (props) { return function () {
        return dispatch(projectActions.UsergroupInvite.inviteRequest(props.inviteRows, [
            projectActions.UsergroupList.fetchRequest('PROJECT', props.projectId)
        ]));
    }; }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#endregion
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
exports.default = enhance(function (props) {
    var message = (React.createElement(React.Fragment, null,
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info')),
            " "),
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info/second')),
            " "),
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info/third')),
            " ")));
    return (React.createElement(GenericInviteModal_1.default, { isOpen: props.isOpen, modalTitle: (0, translation_1.getLocalization)('invite/member'), message: message, status: props.status, inviteRows: props.inviteRows, items: props.all.reduce(function (prev, curr) {
            prev.push(__assign(__assign({}, curr.category), { disabled: curr.category.type === 'CategoryUserGroup' ||
                    curr.category.type === 'SokoBidCategoryUserGroup' ||
                    curr.category.type === 'LightAdminCategoryUserGroup' }));
            curr.groups.forEach(function (g) { return prev.push(g); });
            return prev;
        }, []), addNewToast: props.addNewToast, toggleModal: props.toggleModal, selectItem: props.selectItem, updateEmails: props.updateEmails, updateLanguage: props.updateLanguage, addNewRow: props.addNewRow, removeRow: props.removeRow, inviteText: (0, translation_1.getLocalization)('components/modals/genericInvitationModal/invite'), sendInvitations: props.sendInvitations(props), errors: props.errors, groupStatus: props.userGroupsStatus, exportAddress: "".concat(__APIBASEURL__, "api/project/").concat(props.projectId, "/members") }));
});
